import * as React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import NodeLabel from '../../NodeLabel/NodeLbl';
import { Grid, Box, Modal, Typography } from '@mui/material';
import Tree from 'react-d3-tree';
import '../../style.css';
// import NodeLabelComponent from '../../NodeLabelComponent/NodeLabelComponent';

// const svgSquare = {
//     shape: 'rect',
//     shapeProps: {
//         width: 180,
//         height: 40,
//         x: 0,
//         y: -20,
//         color: '#ffffff',
//     },
// };

const test = {
    shape: 'rect',
    shapeProps: {
        width: 0,
        height: 0,
        x: -20,
        y: 20,
        stroke: '#2F80ED',
    },
};

const TreeAllOKR = ({dataa }: any) => {
    // const [objNameIds, setObjNameIds] = useState<any>();
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedNode, setSelectedNode] = useState<any>(null);

    // const tenantId = useSelector((state: any) => state.meetings.profileTenantId);

    // const onSuccesssGetAllObjectiveData = (data: any) => {
    //     setObjNameIds(data);
    // };

    // const handleNodeClick = (nodeData: any) => {
    //     setSelectedNode(nodeData);
    //     setModalOpen(true);
    // };

    const handleClose = () => {
        setModalOpen(false);
    };

    const dataaa = [
       {
        name: '',score:null
    },
    ];

    return (
        <Grid item xs={12}>
            <Box>
                <div className="AppVer">
                    <div id="treeWrapper" style={{ width: '100%', height: '75vh' }}>
                        <Tree
                            data={dataa !== undefined && dataa != null ? dataa : dataaa}
                            nodeSvgShape={test}
                            pathFunc="straight"
                            separation={{ siblings: 1.55, nonSiblings: 1.55 }}
                            orientation="vertical"
                            translate={{ x: 900, y: 55 }}
                            allowForeignObjects
                            nodeLabelComponent={{
                                render: (
                                    <NodeLabel
                                    // <NodeLabelComponent
                                        className="myLabelComponentInSvg"
                                        nodeData={{ name: '', type:'',score: null }}
                                    />
                                ),
                                foreignObjectWrapper: {
                                    width: 190,
                                    height: 110,
                                    y: -20,
                                    x: -130,
                                },
                            }}
                          //   nodeLabelComponent={{
                          //     render: <NodeLabelComponent />,
                          //     foreignObjectWrapper: {
                          //               width: 190,
                          //               height: 110,
                          //               y: -20,
                          //               x: -130,
                          //           },
                          // }}
                            zoomable={true}
                            initialDepth={0.02}
                            shouldCollapseNeighborNodes={true}
                            ///onClick={handleNodeClick} // اضافه شده
                        />
                    </div>
                </div>
            </Box>

            <Modal open={modalOpen} onClose={handleClose}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <Typography variant="h6" component="h2">
                        Node Information
                    </Typography>
                    <Typography sx={{ mt: 2 }}>
                        {selectedNode ? selectedNode.name : ''}
                    </Typography>
                </Box>
            </Modal>
        </Grid>
    );
};

export default TreeAllOKR;
